export function getMailsRoutes() {
  return [
    {
      path: "/mails",
      name: "mails",
      component: () => import(/* webpackChunkName: mails-old-backend */ "./components/MailsOld.vue"),
    },
  ]
}
